import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


import { ref, onMounted } from 'vue'
import DetailCard from '@/components/DetailCard'
import { queryContractDetail, contractCodeUpdate } from '@/api/gucangSales/customerCenter'
import { useRoute } from 'vue-router'
import { DcMessage } from '@dc-platform/dc-components'
import type { ContractItem } from '@/typings/api/customerCenter'
const __default__ = { name: 'tabsContract ' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  returnName: String
},
  setup(__props) {

const route = useRoute()

const visible = ref(false)
const formRef = ref()
const loading = ref(false)
const editForm = ref<ContractItem>({})
const data = ref<ContractItem[]>([])
const columns = ref([
  { title: '客户名称', dataIndex: 'customerName' },
  { title: '子客户代码', dataIndex: 'arkCode' },
  { title: '合同ID', dataIndex: 'id' },
  { title: '法务合同编码', dataIndex: 'contractCode' },
  { title: '签约业务', dataIndex: 'contractBusiness' },
  {
    title: '服务主体',
    dataIndex: 'serviceSubject',
    node: 'ParamCodesSelect',
    attrs: {
      paramCode: 'fbu_service_body',
      appId: 'cos_fbu',
      view: true
    }
  },
  { title: '合同类型', dataIndex: 'contractType' },
  { title: '线下合同数据同步时间', dataIndex: 'offlineSyncTime' },
  { title: '业务三级分类', dataIndex: 'businessThirdCate' },
  { title: '我方联系人姓名', dataIndex: 'contactName' },
  { title: '我方联系人手机号', dataIndex: 'contactMobile' },
  { title: '我方联系人邮箱', dataIndex: 'contactEmail' },
  { title: '对方联系人姓名', dataIndex: 'counterpartContactName' },
  { title: '对方联系人手机号', dataIndex: 'counterpartContactMobile' },
  { title: '对方联系人邮箱', dataIndex: 'counterpartContactEmail' },
  { title: '当前客户负责人', dataIndex: 'seller' },
  { title: '签约销售代表', dataIndex: 'contractSeller' },
  { title: '我方签约时间', dataIndex: 'contractTime' },
  { title: '客户签约时间', dataIndex: 'counterpartContractTime' },
  { title: '合同创建时间', dataIndex: 'contractCreateTime' }
])
const fetch = () => {
  if (route.query.cosId || route.query.arkCode) {
    queryContractDetail({
      arkCode: route.query.arkCode,
      cosId: route.query.cosId
    }).then((res) => {
      data.value = res.data
    })
  }
}
const viewPdf = (data: ContractItem) => {
  if (data.fileUrl) {
    const eleLink = document.createElement('a')
    eleLink.download = data.fileUrl
    eleLink.style.display = 'none'
    eleLink.href = data.fileUrl
    document.body.appendChild(eleLink)
    eleLink.click()
    document.body.removeChild(eleLink)
  } else {
    DcMessage.warning('暂无合同原件')
  }
}
// 修改合同编码
const showEditModal = (data: ContractItem) => {
  editForm.value = {
    ...data,
    newContractCode: undefined
  }
  visible.value = true
}
const updateCode = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { id, newContractCode } = editForm.value
    contractCodeUpdate({
      id,
      contractCode: newContractCode
    })
      .then((res) => {
        visible.value = false
        DcMessage.success('修改成功')
        fetch()
      })
      .finally(() => {
        loading.value = false
      })
  })
}
onMounted(() => {
  fetch()
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_dc_layout_button_group = _resolveComponent("dc-layout-button-group")!
  const _component_dc_layout_empty = _resolveComponent("dc-layout-empty")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
          return (_openBlock(), _createBlock(_unref(DetailCard), {
            key: index,
            columns: columns.value,
            title: `合同信息${index + 1}`,
            data: item
          }, {
            subTitle: _withCtx(() => [
              _createVNode(_component_dc_layout_button_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: ($event: any) => (viewPdf(item))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("原件预览")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_button, {
                    onClick: ($event: any) => (showEditModal(item))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("变更合同编码")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["columns", "title", "data"]))
        }), 128)),
        (!data.value || !data.value.length)
          ? (_openBlock(), _createBlock(_component_dc_layout_empty, {
              key: 0,
              type: "nothing"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_cos_footer_button, {
      loading: loading.value,
      returnName: __props.returnName,
      hideOk: true
    }, null, 8, ["loading", "returnName"]),
    _createVNode(_component_cos_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
      title: "变更合同编码",
      width: "470px",
      onOk: updateCode,
      confirmLoading: loading.value
    }, {
      default: _withCtx(() => [
        (visible.value)
          ? (_openBlock(), _createBlock(_component_a_form, {
              key: 0,
              model: editForm.value,
              ref_key: "formRef",
              ref: formRef,
              autocomplete: "off"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  name: "contractCode",
                  label: "原合同编码",
                  rules: [{ required: true, message: '请输入' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: editForm.value.contractCode,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.contractCode) = $event)),
                      disabled: true
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  name: "newContractCode",
                  label: "新合同编码",
                  rules: [{ required: true, message: '请输入' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: editForm.value.newContractCode,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((editForm.value.newContractCode) = $event)),
                      placeholder: "请输入"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "confirmLoading"])
  ], 64))
}
}

})